import { render, staticRenderFns } from "./StatisticsCardVertical.vue?vue&type=template&id=52496283&scoped=true&"
import script from "./StatisticsCardVertical.vue?vue&type=script&lang=js&"
export * from "./StatisticsCardVertical.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsCardVertical.vue?vue&type=style&index=0&id=52496283&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52496283",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VCard,VCardText,VCardTitle,VIcon,VSpacer})
